(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["template-password"]) return;
  try {
    
  document.getElementById('logo').addEventListener('click', function () {
    document.getElementById('access').classList.toggle('active')
    document.getElementById('contact').classList.remove('active')
  })
  document.getElementById('open-contact').addEventListener('click', function () {
    document.getElementById('contact').classList.toggle('active')
    document.getElementById('access').classList.remove('active')
  })

  } catch(e) { console.error(e); }
})();
})();
